import {startSubmit, stopSubmit, destroy, arrayPush} from 'redux-form';
import {Observable} from 'rxjs';

import {combineEpics} from 'web-app/util/redux-observable';
import {getApolloClient} from 'web-app/api/clients/famly-app';
import FoodConsumptionActions from 'web-app/react/entities/meals/food-consumption/actions';
import FoodConsumptionActionTypes from 'web-app/react/entities/meals/food-consumption/action-types';
import MealPlanActions from 'web-app/react/entities/meals/meal-plan/actions';
import {getMealTypesForInstitution} from 'web-app/react/entities/meals/meal-plan/selectors';
import {getMealRegistration} from 'web-app/react/entities/meals/food-consumption/selectors';

import ActionTypes from './action-types';
import Actions from './actions';
import * as Constants from './constants';
import * as Queries from '../../meal-plan/queries';

const initialize = action$ =>
    action$
        .ofType(
            ActionTypes.MEALS_MEAL_REGISTRATION_SHOW,
            ActionTypes.MEALS_MEAL_REGISTRATION_EDIT,
            ActionTypes.MEALS_MEAL_REGISTRATION_VIEW,
        )
        .flatMap(() => [destroy(Constants.formName)]);

const fetchMealTypes = (action$, state$) =>
    action$
        .ofType(
            ActionTypes.MEALS_MEAL_REGISTRATION_SHOW,
            ActionTypes.MEALS_MEAL_REGISTRATION_EDIT,
            ActionTypes.MEALS_MEAL_REGISTRATION_VIEW,
        )
        .filter(
            ({payload}) =>
                typeof getMealTypesForInstitution(state$.value, {institutionId: payload.institutionId}) === 'undefined',
        )
        .map(({payload}) => MealPlanActions.fetchMealTypes(payload.institutionId, payload.childId));

const fetchMealRegistration = (action$, state$) =>
    action$
        .ofType(ActionTypes.MEALS_MEAL_REGISTRATION_EDIT, ActionTypes.MEALS_MEAL_REGISTRATION_VIEW)
        .filter(({payload}) => typeof getMealRegistration(state$.value, payload.mealRegistrationId) === 'undefined')
        .map(({payload}) =>
            FoodConsumptionActions.fetchMealRegistration(payload.mealRegistrationId, payload.institutionId),
        );

const lockForm = action$ =>
    action$
        .ofType(
            FoodConsumptionActionTypes.MEAL_REGISTRATIONS_CREATE,
            FoodConsumptionActionTypes.MEAL_REGISTRATION_UPDATE,
        )
        .map(() => startSubmit(Constants.formName));

const unlockFormAndCloseModal = action$ =>
    action$
        .ofType(
            FoodConsumptionActionTypes.MEAL_REGISTRATIONS_CREATE_SUCCESS,
            FoodConsumptionActionTypes.MEAL_REGISTRATION_UPDATE_SUCCESS,
        )
        .flatMap(() => [stopSubmit(Constants.formName), Actions.hide()]);

const unlockForm = action$ =>
    action$
        .ofType(
            FoodConsumptionActionTypes.MEAL_REGISTRATIONS_CREATE_FAILED,
            FoodConsumptionActionTypes.MEAL_REGISTRATION_UPDATE_FAILED,
        )
        .map(() => stopSubmit(Constants.formName));

const createFoodItemObservable = (institutionId, title) =>
    Observable.fromPromise(
        getApolloClient().mutate({
            mutation: Queries.CreateFoodItem,
            variables: {
                institutionId,
                title,
            },
        }),
    ).map(({data}) => {
        return {
            foodItem: data.meals.createFoodItem,
            institutionId,
        };
    });

const createFoodItem = action$ =>
    action$.ofType(ActionTypes.MEALS_MEAL_REGISTRATION_CREATE_FOOD_ITEM).mergeMap(({payload}) =>
        createFoodItemObservable(payload.institutionId, payload.title)
            .flatMap(payload => [
                Actions.createFoodItemSuccess(),
                arrayPush(Constants.formName, 'foodItems', {id: payload.foodItem.id, amount: Constants.defaultAmount}),
            ])
            .catch(e => Observable.of(Actions.createFoodItemFailed(payload.institutionId, payload.title, e))),
    );

const debounceSearch = action$ =>
    action$
        .ofType(ActionTypes.MEALS_MEAL_REGISTRATION_FOOD_ITEM_WRITE_SEARCH)
        .debounceTime(500)
        .mergeMap(({payload}) => [Actions.foodItemSearch(payload.searchTerm)]);

export default combineEpics(
    initialize,
    fetchMealTypes,
    fetchMealRegistration,
    lockForm,
    unlockFormAndCloseModal,
    unlockForm,
    createFoodItem,
    debounceSearch,
);
